import { useTranslation } from "react-i18next";
import { ATTENDANCE_STATUSES, REQUEST_STATUSES } from "../api/constants";
const BadgeStatus = ({ status, className = "", style = {} }) => {
  const { t } = useTranslation();
  const statusLower = status?.toLowerCase();

  const getBadgeClass = () => {
    // Attendance Statuses
    if (status === ATTENDANCE_STATUSES.ASSIGNED) return "bg-primary";
    if (status === ATTENDANCE_STATUSES.ON_TIME) return "bg-success";
    if (
      status === ATTENDANCE_STATUSES.LATE ||
      status === ATTENDANCE_STATUSES.LATE_ALLOWED_TO_WORK ||
      status === ATTENDANCE_STATUSES.LATE_SENT_HOME
    )
      return "bg-danger";
    if (
      status === ATTENDANCE_STATUSES.ABSENT ||
      status === ATTENDANCE_STATUSES.CANCELLED
    )
      return "bg-secondary";

    // Leave/Claim Statuses
    if (statusLower?.includes(REQUEST_STATUSES.PENDING.toLowerCase()))
      return "bg-warning";
    if (status === REQUEST_STATUSES.APPROVED) return "bg-primary";
    if (status === REQUEST_STATUSES.REJECTED) return "bg-danger";
    if (status === REQUEST_STATUSES.CANCELLED) return "bg-secondary";

    return "bg-dark";
  };

  // Only apply badge class if backgroundColor is not provided in style
  const badgeClass = style.backgroundColor ? "" : getBadgeClass();

  return (
    <span
      className={`badge ${badgeClass} ${className}`}
      style={{
        fontSize: 12,
        fontWeight: 500,
        padding: "6px 8px",
        color: "#fff",
        borderRadius: "7px",
        textTransform: "capitalize",
        height: "26px",
        ...style,
      }}
    >
      {status === "Assigned"
        ? t("Assigned")
        : status === "On Time"
        ? t("On Time")
        : status === "Late"
        ? t("Late")
        : status === "Ongoing"
        ? t("Ongoing")
        : t(status)}
    </span>
  );
};

export default BadgeStatus;
